import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import moment from 'moment';

var context = {
  formatXAxis: (d) => {
    // return d3.time.format('%x')(new Date(d));
    return moment(d).format('DD/MM');
  },
  formatYAxis: (d) => {
    return (d);
  },
};


class MultiBarHistoryChartComponent extends Component {
  render() {
    if (this.props.data) {
      return (
        <div>
          <NVD3Chart
            id="barChart"
            type={this.props.horizontal ? 'multiBarHorizontalChart' : 'multiBarChart'}
            datum={this.props.data}
            context={context}
            xAxis={{
                tickFormat: {
                name:'formatXAxis',
                type:'function',
                }
            }}
            yAxis={{
                tickFormat: {
                name:'formatYAxis',
                type:'function',
                }
            }}
            margin={this.props.horizontal ? {left: 100} : {right:0}}
            showControls={false}
            stacked={true}
            x={(d) => {
              const date = moment(d.date);
              return date.valueOf();
            }}
            y={(d) => (d.ratings || d.emailsCount || 0)}
            height={this.props.horizontal ? 850 : 250}
          />
        </div>
      );
    }
    return;
  }
}

MultiBarHistoryChartComponent.propTypes = {
  horizontal: PropTypes.bool,
  data: PropTypes.array.isRequired,
};

export default MultiBarHistoryChartComponent;



// WEBPACK FOOTER //
// ./src/components/RatingsHistoryChartComponent.js